import React from 'react';

import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {SmartChipType} from 'ui-library/chips/useSmartChipQuery';
import {apiIdToIconName} from 'util/APIUtil';
import {BasicEvent} from 'util/Types';

export interface SampleDefinitionChipProps extends SharedSmartChipProps<SmartChipType.SAMPLE_DEFINITION> {}

export default function SampleDefinitionChip(props: SampleDefinitionChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: sampleDefinition,
    handleClickLink,
    isInaccessible,
  } = useSmartChipQuery<SmartChipType.SAMPLE_DEFINITION>({
    id,
    onClick,
  });

  // If the onClick property is provided, use that. Otherwise, use the default SmartChip behavior
  // (Note that with a null URL assigned, the default click behavior should be a no-op)
  const handleClickLinkEnhanced = (e: BasicEvent): void => {
    if (sampleDefinition) {
      if (props.onClick != null) {
        handleClickLink(e);
      }
    }
  };

  const sampleDefinitionId = sampleDefinition?.id;

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={sampleDefinitionId ? apiIdToIconName(sampleDefinitionId) : null}
      isInaccessible={isInaccessible}
      item={sampleDefinition}
      onClick={handleClickLinkEnhanced}
      url={null}
    />
  );
}
